export const getFeatureCropCoors = (feature) => {
  if (!feature.metaData["CropCoords"]) {
    return null
  }
  if (!feature.metaData["ParsedCropCoords"]) {
    if ((feature.metaData["CropCoords"].length === 1) && (typeof feature.metaData["CropCoords"][0] === "string")) {
      if (feature.metaData["CropCoords"][0].includes(", ")) {
        feature.metaData["ParsedCropCoords"] = feature.metaData["CropCoords"][0].split(", ").map(coor => +coor)
      } else if (feature.metaData["CropCoords"][0].includes(",")) {
        feature.metaData["ParsedCropCoords"] = feature.metaData["CropCoords"][0].split(",").map(coor => +coor)
      }
    } else {
      feature.metaData["ParsedCropCoords"] = feature.metaData["CropCoords"];
    }
  }
  return feature.metaData["ParsedCropCoords"]
}
